import i18n from "i18next";
import { initReactI18next } from "react-i18next";

i18n.use(initReactI18next).init({
  debug: true,
  fallbackLng: "pl",
  lng: "pl",
  ns: ["translations"],
  defaultNS: "translations",
  resources: {
    en: {
      translations: {
        text1: "Hi, I`m",
        text2: "Jakub Michalski",
        text3: "I`m a ",
        frontendDeveloper: "Frontend Developer",
        uxuidesigner: "UX/UI Designer",
        programmer: "Programmer",
        description: "Lodz, Poland",
        download: "Download CV",
        about: "About",
        career: "Career",
        skills: "Skills",
        projects: "Projects",
        contact: "Contact",
        aboutMe: "About me",
        about1:
          "From a young age I was interested in playing games and many things related to computers. After finishing primary school I knew that I wanted to connect my future with computer science.",
        about2:
          "In 2023, I graduated from engineering studies at one of the best technical universities in Poland, Lodz University of Technology, majoring in Computer Science, specializing in Internet Technologies. Over 3.5 years, I acquired strong programming skills in C, C++, Java, and Python, and gained knowledge about databases, web and mobile applications, and software engineering. A year later, I graduated from the same university with a master's degree in Applied Computer Science, specializing in User Interfaces and Usability Research (UX/UI). I gained knowledge in the field of designing web and mobile application interfaces, usability research, and data analysis.",
        about3:
          "During all this time I managed to build a good reputation and complete many larger or smaller programming projects. I am a person very open to new experiences and I learn very quickly. I have great communication skills and I can work in a team. In my free time I like to watch football matches or relax with computer games. In the summer I try to spend a lot of time outdoors.",
        about4:
          "Thank you for getting to know me better. If you have any questions, please contact me.",
        interest1: "New IT technologies",
        interest2: "Games",
        interest3: "Football",
        interest4: "Fishing",
        namePl: "Lodz University of Technlogy",
        nameHanze:
          "Hanze University of Applied Sciences, Groningen Netherlands",
        faculty1: "EEIA Faculty",
        faculty2: "FTIMS Faculty",
        firstCycle: "Full-time first cycle studies",
        secondCycle: "Full-time second cycle studies",
        fieldOfStudy1: "Computer Science",
        fieldOfStudy2: "Applied Computer Science",
        specialization1: "Internet Technologies",
        specialization2: "User interfaces and usability testing (UI/UX)",
        erasmus: "Erasmus",
        erasmusProgram: "Smart Energy Program",
        years1: "2019 - 2023",
        years2: "2022",
        years3: "2023 - 2024",
        experienceDate5: "October 2021 - February 2022",
        experienceDate4: "October 2022 - February 2023",
        experienceDate3: "October 2022 - December 2022",
        experienceDate2: "May 2023 - October 2023",
        experienceDate1: "November 2023 - July 2024",
        experienceName5: "Salesforce Developer - Craftwere",
        experienceName4: "Frontend Developer - KanapkaMan",
        experienceName3: "React Native Developer - Romify",
        experienceName2: "Junior Frontend Developer - DeveloArt",
        experienceName1: "Business Expert - Commerzbank",
        experienceDesc5:
          "Basics of Salesforce, cloud programming, Einstein bots",
        experienceDesc4: "Building websites using Vue.js and React",
        experienceDesc3:
          "Developing the existing mobile application and fixing the bugs reported by users",
        experienceDesc2:
          "Building websites and mobile websites using React and React Native",
        experienceDesc1:
          "Implementing new and updating current APIs for the bank and external clients",
        section1: "Frontend",
        section2: "Backend",
        section3: "Programming",
        section4: "Tools & Environments",
        section5: "Soft skills",
        novice: "Novice",
        begginer: "Begginer",
        competent: "Competent",
        proficient: "Proficient",
        expert: "Expert",
        problemSolving: "Problem Solving",
        teamwork: "Group Collaboration",
        communication: "Interpersonal Communication",
        timeManagement: "Time Management",
        adaptability: "Fast Adaptability",
        project1name: "OffRoad",
        project2name: "Educational Game",
        project3name: "Licence Plate Reader",
        project4name: "Hand Gesture Recognition",
        project5name: "Currency Exchange",
        project6name: "Maze",
        project1description:
          "A mobile app written in react native, designed for people interested in off-road. It allows you to report help to others or ask for it.",
        project2description:
          "An educational game for children about environmental protection. Created on the Godot game engine.",
        project3description:
          "License plate reader written in C++. Allows reading license plates and keeping statistics of read plates.",
        project4description:
          "Hand gesture recognition algorithm written in Python. Allows to recognize different gestures. Written for the needs of master's thesis.",
        project5description:
          "A simple currency calculator written in React. It allows you to check the rates of the most popular currencies and convert them.",
        project6description:
          "A multi-threaded game that involves going through a maze alone or with several people. It involves collecting coins and escaping from the beast. Programmed in C.",
        contactDescription:
          "Got a question or proposal, or just want to say hello? Go ahead.",
        contactName: "Name",
        contactEmail: "Email",
        contactMessage: "Message",
        send: "Send",
        successMessage: "Your message was sent successfully!",
        errorMessage:
          "There was an error sending your message. Please try again later.",
      },
    },
    pl: {
      translations: {
        text1: "Cześć, nazywam się",
        text2: "Jakub Michalski",
        text3: "Jestem ",
        frontendDeveloper: "Frontend Developerem",
        uxuidesigner: "UX/UI Developerem",
        programmer: "Programistą",
        description: "Łódź, Polska",
        download: "Pobierz CV",
        about: "O mnie",
        career: "Kariera",
        skills: "Wiedza",
        projects: "Projekty",
        contact: "Kontakt",
        aboutMe: "O mnie",
        about1:
          "Już od najmłodszych lat interesowałem się graniem w gry oraz wieloma rzeczami związanymi z komputerami. Po ukończeniu szkoły podstawowej wiedziałem, że swoją przyszłość chciałbym łączyć z informatyką.",
        about2:
          "W 2023 roku ukończyłem studia inżynierskie na jednej z najlepszych uczelni technicznych w Polsce, Politechnice Łodzkiej na kierunku Informatyka na specjalizacji Technologie Internetowe. Przez 3,5 roku zdobyłem silne umiejętności programowania w języku C, C++, Java i Python oraz zyskałem wiedzę na temat baz danych, aplikacji webowych i mobilnych oraz inżynierii oprogramowania. Rok później ukończyłem studia magisterskie na tej samej uczelni na kierunku Informatyka Stosowana na specjalizacji Interfejsy Użytkownika i Badania Użyteczności (UX/UI). Zdobyłem wiedzę z zakresu projektowania interfejsów aplikacji webowych i mobilnych oraz badań użyteczności i analizy danych.",
        about3:
          "Przez cały ten czas udało mi się zbudować dobrą reputację oraz ukończyć wiele większych bądź mniejszych projektów programistycznych. Jestem osobą otwartą na nowe doświadczenia oraz bardzo szybko się uczę. Posiadam duże umiejętności komunikacyjne oraz potrafię pracować w grupie. W wolnym czasie chętnie oglądam mecze piłki nożnej lub relaksuję się przy grach komputerowych. W okresie letnim dużo czasu staram się spędzać na świeżym powietrzu.",
        about4:
          "Dziękuję za poznanie mnie bliżej. Jeżeli masz jakieś pytania, zapraszam do kontaktu.",
        interest1: "Nowe technologie",
        interest2: "Gry",
        interest3: "Piłka nożna",
        interest4: "Wędkarstwo",
        namePl: "Politechnika Łódzka",
        nameHanze: "Uniwersytet Nauk Stosowanych Hanze, Groningen Holandia",
        faculty1: "Wydział EEIA",
        faculty2: "Wydział FTIMS",
        firstCycle: "Studia stacjonarne I stopnia",
        secondCycle: "Studia stacjonarne II stopnia",
        fieldOfStudy1: "Informatyka",
        fieldOfStudy2: "Informatyka Stosowana",
        specialization1: "Technologie Internetowe",
        specialization2:
          "Interfejsy Użytkownika i Badania Użyteczności (UI/UX)",
        erasmus: "Erasmus",
        erasmusProgram: "Program Inteligentnej Energii",
        years1: "2019 - 2023",
        years2: "2022",
        years3: "2023 - 2024",
        experienceDate5: "Październik 2021 - Luty 2022",
        experienceDate4: "Październik 2022 - Luty 2023",
        experienceDate3: "Październik 2022 - Grudzień 2022",
        experienceDate2: "Maj 2023 - Październik 2023",
        experienceDate1: "Listopad 2023 - Lipiec 2024",
        experienceName5: "Programista Salesforce - Craftwere",
        experienceName4: "Frontend Developer - KanapkaMan",
        experienceName3: "Programista React Native - Romify",
        experienceName2: "Junior Frontend Developer - DeveloArt",
        experienceName1: "Business Expert - Commerzbank",
        experienceDesc5:
          "Podstawy Salesforce, programowanie w chmurze, tworzenie Einstein botów",
        experienceDesc4:
          "Tworzenie stron internetowych przy użyciu Vue.js i React",
        experienceDesc3:
          "Rozwijanie istniejącej aplikacji mobilnej i naprawianie błędów zgłaszanych przez użytkowników",
        experienceDesc2:
          "Tworzenie stron internetowych i mobilnych przy użyciu React i React Native",
        experienceDesc1:
          "Wdrażanie nowych i aktualizacja obecnych interfejsów API dla banku i klientów zewnętrznych",
        section1: "Frontend",
        section2: "Backend",
        section3: "Programowanie",
        section4: "Narzędzia & Środowiska",
        section5: "Umiejętności miękkie",
        novice: "Nowicjusz",
        begginer: "Początkujący",
        competent: "Kompetentny",
        proficient: "Zaawansowany",
        expert: "Ekspert",
        problemSolving: "Rozwiązywanie problemów",
        teamwork: "Praca Zespołowa",
        communication: "Komunikacja Interpersonalna",
        timeManagement: "Zarządzanie czasem",
        adaptability: "Szybka Adaptowalność",
        project1name: "OffRoad",
        project2name: "Gra Edukacyjna",
        project3name: "Czytnik Tablic Rejestracyjnych",
        project4name: "Rozpoznawanie Gestów Dłoni",
        project5name: "Kantor Walutowy",
        project6name: "Labirynt",
        project1description:
          "Aplikacja mobilna napisana w react native, przeznaczona dla ludzi związanych offroadem. Umożliwia zgłoszenie pomocy innym lub poproszenie o nią.",
        project2description:
          "Edukacyjna gra dla dzieci o tematyce ochrony środowiska. Stworzona na silniku gry Godot.",
        project3description:
          "Czytnik tablic rejestracyjnych napisany w języku C++. Umożliwia sczytywanie tablic rejestracyjnych oraz prowadzenie statystych odczytanych tablic.",
        project4description:
          "Algorytm rozpoznawania gestów dłoni napisany w języku Python. Umożliwia rozpoznawanie kilku gestów. Napisany na potrzeby pracy magisterskiej.",
        project5description:
          "Prosty kalkulator walutowy napisany w React. Umożliwia sprawdzenie kursów wielu walut oraz ich przeliczanie.",
        project6description:
          "Wielowątkowa gra polegająca na przechodzenie labiryntu samemu lub w kilka osób. Polega na zbieraniu monet i uciekaniu przed bestią. Napisana w języku C.",
        contactDescription:
          "Masz pytanie lub propozycję, albo po prostu chcesz się przywitać? Zapraszam do kontaktu.",
        contactName: "Imię",
        contactEmail: "Email",
        contactMessage: "Wiadomość",
        send: "Wyślij",
        successMessage: "Twoja wiadomość została wysłana!",
        errorMessage:
          "Wystąpił błąd podczas wysyłania wiadomości. Spróbuj ponownie później.",
      },
    },
  },
});

export default i18n;
